/**
 * User-facing action names. Command/event keys and legacy search keywords stay stable.
 * Counts: filter chips count matches for the current query, independent of the
 * selected chip; library totals remain visible, Favorites explicitly says total;
 * a selection has one summary owned by collection chrome. Use pluralize for nouns.
 */
export const SAVE_LABELS = Object.freeze({
  json: 'Download .json',
  zip: 'Download .zip',
  cloud: 'Save to cloud',
  // BC-7: History is one surface; its nouns are "named versions", "automatic
  // saves" and "cloud versions" (History Timeline rule: two nouns for one
  // record is a vocabulary bug).
  checkpoint: 'Name this version…',
  history: 'Save and history',
  fullHistory: 'Open history…',
  manageSaved: 'Manage snapshots…',
  versions: 'Cloud versions',
  review: 'Review changes since last export…',
  retry: 'Retry save',
  retrySync: 'Retry sync',
  resolveConflict: 'Choose a version…',
  recoveryCopy: 'Download a recovery copy',
  backupComplete: 'Complete backup — project and images',
  backupData: 'Project data only — images stay linked',
  template: 'Save as template…'
});
export const PROJECT_LABELS = Object.freeze({
  openFile: 'Open project file…',
  newProject: 'New project…',
  projects: 'My projects…',
  previews: 'My previews',
  templates: 'Browse templates…',
  importBrand: 'Import brand from URL…',
  startOver: 'Start over…',
  design: 'Design',
  links: 'Links…',
  code: 'Code injection',
  fleet: 'Client fleet'
});
export const SIDEBAR_TAB_LABELS = Object.freeze({
  sections: 'Sections',
  design: 'Design',
  project: 'Project',
  audit: 'Publish checks'
});
export const PUBLISH_LABELS = Object.freeze({
  publish: 'Publish',
  site: 'Publish site',
  share: 'Share',
  shareMenu: 'Share…',
  comments: 'Comments…',
  preview: 'Save preview…',
  html: 'Export HTML',
  eleventy: 'Export 11ty project',
  astro: 'Export Astro project',
  chooseAddress: 'Choose an address…',
  manageAddress: 'Manage address…'
});
export const HELP_LABELS = Object.freeze({
  find: 'Find anything',
  shortcuts: 'Keyboard shortcuts',
  tour: 'Take the tour',
  restartTour: 'Restart tour — reset progress',
  report: 'Report an issue…',
  reports: 'Your reports'
});
export const RETIRED_TERMS = Object.freeze([
  'URL-ready',
  'Home-only',
  'No URL skin',
  'Quick Save',
  'Quick save',
  'Full Save',
  'Full save',
  'Load Project',
  'Skin from URL',
  'Ship',
  'Save as Template',
  'Keyboard Shortcuts',
  'Tour Guide',
  'Open Templates',
  'Publish to the web'
]);
